<template>
  <div class="header">
    <div class="headernav" style="position: relative;z-index: 2022 ;">
      <div class="headernav-logo">
        <el-image :src="require('../../assets/image/header/headerlogo.png')" fit="fill"></el-image>
      </div>
      <div class="headernav-nav">
        <div class="nav-items">
          <div class="el-tabs__active-bar" id="bar" ref="headerBar"></div>
          <div :class="(item.url.split('/')[1] == routerPath ? 'is-active' : '')" :key="index" :ref="item.url.split('/')[1]" @click="jumpRouter(item)" class="nav-item" v-for="(item, index) in nvaBar">
            {{item.title}}
          </div>
        </div>
        <div class="nav-login" v-if="!getUserLogin">
          <div @click="loginBtn">登录</div>
          <div @click="signBtn">注册</div>
        </div>
        <div @click="exitLogin" class="exit-login" v-else>
          <el-tooltip :content="'欢迎您：'+$store.state.userInfo.userName+' 点击退出登录'" class="item" effect="dark" placement="top-start">
            <div> {{ $store.state.userInfo.userName }}</div>
          </el-tooltip>
        </div>
      </div>
    </div>
    <Login ref="Login"/>
    <Sign ref="Sign"/>
  </div>
</template>
<script>
  import Login from "./login/Login.vue"
  import Sign from './login/Sign.vue'

  export default {
    name: "Header",
    components: {
      Login,
      Sign
    },
    data() {
      return {
        nvaBar: [
          {
            title: '首页',
            url: '/index',
          },
          // {
          //   title:'资源',
          //   url:'/resource',
          // },
          {
            title: '新闻',
            url: '/news',
          },
          {
            title: '古壮字输入法',
            url: '/diction'
          },
          {
            title: '古籍征集',
            url: '/reader',
          },
        ],

      };
    },
    mounted() {
      // this.$refs.Login.openDialog(false);
      this.init()
    },
    methods: {
      init() {
        this.setBarWidth(this.$route.path)
      },
      setBarWidth(item) {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let ref = item.split('/')[1]
        if (ref == 'resource') {
          var w = this.$refs.headerBar
          w.setAttribute('style', ' transform: translateX(-100%)');
          return
        }
        if (!this.$refs[ref]) return
        var t = this.$refs[ref][0]
        var tem = t.offsetLeft / fontSize
        var widht = t.clientWidth
        var intewidht = parseInt(widht) / fontSize
        var w = this.$refs.headerBar
        w.setAttribute('style', ' transform: translateX(' + tem + 'rem);width:' + intewidht + 'rem;background-color:#582800;');
      },
      jumpRouter(item) {
        // this.setBarWidth(item.url)
        this.$refs.Login.dialogVisible = false;
        this.$refs.Sign.dialogVisible = false;
        this.$router.push(item.url)
      },
      loginBtn() {
        this.$refs.Login.openDialog(false);
      },
      signBtn() {
        this.$refs.Sign.openDialog(false);
      },
      exitLogin() {
        this.$store.commit("setUserInfo", {
          userId: "",
          userName: "",
        });
        sessionStorage.removeItem("portal_user_info");
        this.$router.go(0)
        this.$router.push({path: "/"});
      }
    },
    computed: {
      routerPath() {
        return this.$route.path.split("/")[1]
      },
      getUserLogin() {
        return sessionStorage.getItem("portal_user_info")
      },
    },
    watch: {
      '$route.path': {
        handler: function (news, old) {
          this.setBarWidth(news)
        },
      }
    }
  };
</script>
<style lang="less" scoped>
  .headernav {
    max-width: calc(49.479rem + 14.01rem);
    margin: 0 auto;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // position: relative;
    // z-index: 2003 ;
    .headernav-logo {
      .el-image {
        width: 14.01rem;
        height: 2.188rem;
      }
    }

    .headernav-nav {
      display: flex;
      height: 100%;
      align-items: center;

      .nav-items {
        display: flex;
        align-items: center;
        color: #582800;
        font-size: 1.042rem;
        width: 34.271rem;
        justify-content: space-around;
        height: 100%;
        cursor: pointer;
        position: relative;

        .el-tabs__active-bar {
          width: 100%;
          position: absolute;
          bottom: 0;
          height: 2px;
          z-index: 2;
          background-color: transparent;
          -webkit-transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
          transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
          transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
          transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
          -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
          list-style: none;
        }

        .nav-item {
          height: 100%;
          display: flex;
          align-items: center;
          letter-spacing: 0.021rem;
        }

        .nav-item:hover {
          text-decoration: none;
          text-shadow: 0 0 0.65px #582800;
        }
      }

      .nav-login {
        display: flex;
        align-items: center;
        font-size: 1.042rem;

        div:last-child {
          border-left: 1px solid #333;
          padding-left: 1rem;
          margin-left: 1rem;
        }

        div {
          cursor: pointer;
        }
      }

      .exit-login {
        max-width: 100px;
        cursor: pointer;

        .el-tooltip.item {
          overflow: hidden; //超出的文本隐藏
          text-overflow: ellipsis; //溢出用省略号显示
          white-space: nowrap; // 默认不换行；
        }

      }
    }
  }
</style>
